import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import CompaniesActionCell from "components/CustomCells/CompaniesActionCell";
import _ from "lodash";

function CompaniesList() {
  const [companiesData, setCompaniesData] = useState([]);
  const companiesColumns = [
    { Header: "ID", accessor: "id", width: "5%" },
    { Header: "ΑΦΜ", accessor: "vatNumber", width: "10%" },
    {
      Header: "ΧΡΗΣΤΗΣ",
      accessor: "username",
      width: "10%",
      Cell: ({ value }) => (
        <SoftBadge variant="contained" color="info" size="xs" badgeContent={value} container />
      ),
    },
    { Header: "ΟΝΟΜΑ", accessor: "name", width: "25%" },
    { Header: "ΔΙΕΥΘΥΝΣΗ", accessor: "address" },
    {
      Header: "ΚΑΤΑΣΤΑΣΗ",
      accessor: "deletedAt",
      Cell: ({ value }) =>
        value === null ? (
          <SoftBadge
            variant="contained"
            color="success"
            size="xs"
            badgeContent="ΕΝΕΡΓΗ"
            container
          />
        ) : (
          <SoftBadge
            variant="contained"
            color="error"
            size="xs"
            badgeContent={`ΑΝΕΝΕΡΓΗ ΑΠΟ: ${value}`}
            container
          />
        ),
    },
    {
      Header: "ΣΥΜΒΑΣΗ",
      accessor: "activationStatus",
      Cell: ({ value }) =>
        value === "DRAFT" ? (
          <SoftBadge
            variant="contained"
            color="error"
            size="xs"
            badgeContent="ΕΚΚΡΕΜΗΣ"
            container
          />
        ) : value === "PENDING_SIGNATURE" ? (
          <SoftBadge
            variant="contained"
            color="warning"
            size="xs"
            badgeContent="ΑΝΥΠΟΓΡΑΦΗ"
            container
          />
        ) : (
          <SoftBadge
            variant="contained"
            color="success"
            size="xs"
            badgeContent="ΥΠΟΓΕΓΡΑΜΜΕΝΗ"
            container
          />
        ),
    },
    {
      Header: "ΔΙΑΒΙΒΑΣΗ",
      accessor: "transmissionBlocked",
      Cell: ({ value }) =>
        !value ? (
          <SoftBadge variant="contained" color="success" size="xs" badgeContent="ΝΑΙ" container />
        ) : (
          <SoftBadge variant="contained" color="error" size="xs" badgeContent="ΟΧΙ" container />
        ),
    },
    { Header: "ΥΠΟΛΟΙΠΟ ΠΑΡΑΣΤΑΤΙΚΩΝ", accessor: "credits" },
    { Header: "ΕΝΕΡΓΕΙΕΣ", accessor: "actions" },
  ];

  useEffect(() => {
    getCompaniesData();
  }, []);

  const getCompaniesData = async () => {
    const response = await ApiService.getData(`/api/v1/companies`);
    if (!response) {
      ToastUtils.error("Αδυναμία εύρεσης εταιρειών!");
      return;
    }

    const companies = response.data.data;
    const formattedData = [];

    for (let company of _.orderBy(companies, "id", "asc")) {
      let forComp = {
        id: company.id,
        vatNumber: company.vatNumber,
        branch: company.branch,
        name: company.friendlyName ? company.friendlyName : company.name,
        username: company.user.firstName + " " + company.user.lastName,
        address: `${company.street} ${company.streetNumber}, ${company.city} ${company.postalCode}`,
        deletedAt: company.deletedAt,
        credits: company.credits,
        activationStatus: company.activationStatus,
        transmissionBlocked: company.apiKey === null,
        actions: company.deletedAt ? null : (
          <CompaniesActionCell
            apiKey={company.apiKey}
            companyId={company.id}
            companyName={company.friendlyName ? company.friendlyName : company.name}
            refreshTable={getCompaniesData}
          />
        ),
      };
      formattedData.push(forComp);
    }

    setCompaniesData(formattedData);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Λίστα Εταιρειών
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Η λίστα περιέχει τις εταιρείες που έχουν προστεθεί στο λογαριασμό σας.
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <DataTable
            table={{ rows: companiesData, columns: companiesColumns }}
            entriesPerPage={{
              defaultValue: 10,
              entries: [5, 10, 20],
            }}
            canSearch
            isSorted
          />
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CompaniesList;
